<template>
  <v-content class="grey lighten-3 fill-height">
    <div id="core-view">
      <v-fade-transition mode="out-in">
        <router-view />
      </v-fade-transition>
    </div>
  </v-content>
</template>

<script>
export default {
  name: 'CoreView',

  metaInfo() {
    return {
      title: 'Intranet DriveUP',
    }
  },
}
</script>
